import paymentMethodServicesConfig from './configs/paymentMethodsServices.json';
import paymentOptionServiceConfig from './configs/paymentOptionServiceConfig.json';
import avsServicesConfig from './configs/avsServicesConfig.json';

export default [
].concat(paymentMethodServicesConfig)
  . concat(paymentOptionServiceConfig)
  . concat(avsServicesConfig);
